// Site proof content: admin-editable via /admin, falls back to placeholders in site.js.
import { useEffect, useState } from "react";
import { getProofContent } from "@/lib/api";
import { TRUSTED_BY, TESTIMONIALS, CASE_STUDIES, RATINGS, PROOF_BADGES } from "@/lib/site";

const PLACEHOLDERS = {
  logos: TRUSTED_BY.map((name) => ({ name })),
  testimonials: TESTIMONIALS,
  ratings: RATINGS,
  case_studies: CASE_STUDIES,
  badges: PROOF_BADGES.map((label) => ({ label })),
};

let cache = null;
let inflight = null;

export const loadProof = () => {
  if (cache) return Promise.resolve(cache);
  if (!inflight) inflight = getProofContent().then((d) => { cache = d; return d; }).catch(() => (cache = {}));
  return inflight;
};
export const invalidateProof = () => { cache = null; inflight = null; };

export const resolveSection = (proof, key) => {
  const sec = proof?.[key];
  if (!sec || sec.mode === "placeholder") return { items: PLACEHOLDERS[key], mode: "placeholder" };
  if (sec.mode === "hidden") return { items: [], mode: "hidden" };
  return { items: sec.items?.length ? sec.items : PLACEHOLDERS[key], mode: "custom" };
};

export const useProof = (key) => {
  const [proof, setProof] = useState(cache);
  useEffect(() => { let on = true; loadProof().then((d) => on && setProof(d)); return () => { on = false; }; }, []);
  return { ...resolveSection(proof, key), loaded: !!proof };
};

export { PLACEHOLDERS };
